import { Link, useParams } from "react-router-dom";
import { PRODUCTS } from "@/data/products";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ProductDetail() {
  const { id } = useParams();
  const p = PRODUCTS.find((x) => x.id === id);
  if (!p) return <div className="section-y container-x">Not found. <Link to="/shop" className="text-sage-700">Back to shop</Link></div>;
  const related = PRODUCTS.filter(x => x.category === p.category && x.id !== p.id).slice(0, 3);
  return (
    <div className="section-y" data-testid="product-detail-page">
      <div className="container-x">
        <Link to="/shop" className="inline-flex items-center gap-1 text-sm text-sage-700 mb-6"><ArrowLeft className="w-4 h-4" /> Back to shop</Link>
        <div className="grid lg:grid-cols-2 gap-10">
          <div className="rounded-3xl overflow-hidden bg-sand-100 aspect-square">
            <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
          </div>
          <div>
            <div className="overline text-clay-600">{p.category}</div>
            <h1 className="font-display text-4xl lg:text-5xl text-sage-800 mt-3">{p.name}</h1>
            <div className="text-2xl text-sage-800 mt-4">${p.price}</div>
            <p className="mt-6 text-sage-800/70 leading-relaxed">{p.description}</p>
            <div className="mt-8 flex gap-3">
              <Button onClick={()=>toast.success("Added to cart", { description: "Checkout is powered by Shopify — coming soon."})} className="btn-pill h-12 px-8 bg-sage-700 hover:bg-sage-800 text-white" data-testid="add-to-cart">Add to Cart</Button>
              <Button variant="outline" className="btn-pill h-12 px-6 border-sage-700/30 text-sage-800" asChild><Link to="/book/consult">Ask a provider</Link></Button>
            </div>
            <div className="mt-10 text-xs uppercase tracking-widest text-sage-800/50">Free shipping over $75 · Third-party tested</div>
          </div>
        </div>

        {related.length > 0 && (
          <div className="mt-24">
            <div className="overline">You may also like</div>
            <div className="grid sm:grid-cols-3 gap-5 mt-6">
              {related.map(r => (
                <Link key={r.id} to={`/shop/${r.id}`} className="card-lift rounded-3xl bg-white border border-sand-200/60 overflow-hidden">
                  <div className="aspect-square bg-sand-100"><img src={r.image} alt={r.name} className="w-full h-full object-cover" /></div>
                  <div className="p-5"><div className="font-display text-lg">{r.name}</div><div className="text-sage-800/60 text-sm mt-1">${r.price}</div></div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
